import React from 'react';
import styled from 'styled-components';

const WrapDiv = styled.div`
  width: ${props => props.width ? `${props.width}` : '100%'};
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;
const ContainerLabel = styled.label`
  width: ${props => props.rowItemCount ? `${100 / props.rowItemCount}` : '25%'};
  display: block;
  position: relative;
  padding-left: 29px;
  cursor: pointer;
  font-size: 15px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  & span {
    position: absolute;
    top: 2px;
    left: 0;
    height: 18px;
    width: 18px;
    border-radius: 50%;
    border: 2px solid #1E2228;
    &:after {
      content: "";
      position: absolute;
      display: none;
    }
  }
  & input {
    width: 0px;
    position: absolute;
    opacity: 0;
    &:checked ~ span {
      border: none;
      background-color: #FF2C91;
    }
  }
`;

const RadioButton = (props) => {
  const { width, list, name, active, selected  } = props;
  return (
    <WrapDiv style={{ width: width }}>
      { list && list.map((item, index) => (
        <ContainerLabel key={`${name}_${index}`}>{item.title}
          <input type="radio" checked={item.id === active[name]} name={name} onChange={() => selected(item.id, name)} />
          <span />
        </ContainerLabel>
      )) }
    </WrapDiv>
  );
}

export default RadioButton;